import React, { Component } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import ApiConnect from "../../../../Utils/ApiConnect";
// import { format } from "date-fns";
import { connect } from "react-redux";
import { setStockUpdate } from "../../../../redux/actions/Modules.Action";
class StockUpdate extends Component {
  FetchOrderSummary = async () => {
    try {
      ApiConnect.get("/Dashboard/Summary/StockUpdate")
        .then((response) => {
          this.props.setStockUpdate(response.data);
        })
        .catch((err) => console.error(err));
    } catch (err) {
      console.log("error facing location:", err);
    }
  };
  componentDidMount = async () => {
    this.FetchOrderSummary();
  };
  formatValue = (value) => `${Number(value).toFixed()}`;
  render() {
    const StockData = this.props.StockDetails;

    return (
      <React.Fragment>
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Stock Update</h4>
              {StockData ? StockData.length : 0} Items
            </div>
            <div className="card-body flexbox flex-justified">
              <Scrollbars style={{ height: "calc(100vh - 55ex)" }}>
                {StockData ? (
                  <table className="table table-striped table-hover">
                    <tbody>
                      {StockData.map((product, index) => (
                        <tr key={index}>
                          <td>{product.name}</td>
                          <td className="text-muted w-80px">
                            {product.min_stock}
                          </td>
                          <td className="text-danger fw-500 w-90px">
                            {product.stock}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  ""
                )}
              </Scrollbars>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default connect(
  (state) => ({
    StockDetails: state.Dashboard.stockUpdate,
  }),
  { setStockUpdate }
)(StockUpdate);
